import { FC, useEffect, useState } from 'react'
import usePagination from '@/hooks/usePagination'
import Pagination from '@UI/New/Pagination'
import { directionOrdersApi } from '@/api'
import { IFinancialTransactionsReportData } from './utils/types'
import ExerciseHomeworkReportTable from './FinancialTransactionsReportTable/FinancialTransactionsReportTable'
import cn from './index.module.css'

interface IFinancialTransactionsReport {
  userId: number
}

const FinancialTransactionsReport: FC<IFinancialTransactionsReport> = ({
  userId,
}) => {
  const [sorting, setSorting] = useState<
    { key: string; order: 'asc' | 'desc' | 'none' }[]
  >(
    [].map((item) => {
      return { key: item, order: 'none' }
    }),
  )

  const onSortingClick = (key: string) => {
    setSorting((prev) =>
      prev.map((item) => {
        const order =
          key === item.key
            ? item.order === 'none'
              ? 'asc'
              : item.order === 'asc'
              ? 'desc'
              : 'none'
            : 'none'

        return { ...item, order: order }
      }),
    )
  }

  const getFilters = () => {
    const filterParams: Record<string, string> = {}

    filterParams['user-id'] = String(userId)

    return filterParams
  }

  const {
    state,
    loading,
    getState: getData,
    setState,
    ...params
  } = usePagination({
    api: directionOrdersApi.getHistory,
    params: { ...getFilters() },
  })

  useEffect(() => {
    const handler = setTimeout(() => {
      getData()
      params.setCurrentPage(1)
    }, 250)

    return () => {
      clearTimeout(handler)
    }
  }, [sorting, userId])

  const reportData = state as unknown as IFinancialTransactionsReportData
  return (
    <div className={cn.content}>
      <ExerciseHomeworkReportTable
        loading={loading}
        data={reportData}
        sorting={sorting}
        onSortingClick={onSortingClick}
      />
      <Pagination {...{ ...params }} />
    </div>
  )
}

export default FinancialTransactionsReport
